import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { TransferInputs } from "./TransferInputs";

export const TransferEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm className="max-w-3xl">
      <TransferInputs />
    </SimpleForm>
  </Edit>
);
